<template>
  <div>
    <Preparing v-if="isPreparing" />

    <div v-if="!isPreparing" class="container-fluid">
      <div class="card card-item">
        <div class="card-body">
          <h3 class="fs-22 font-weight-semi-bold pb-2">گزارشات مالی</h3>
          <div class="row">
            <div class="col-lg-12">
              <DataTable
                ref="dt"
                :value="teacherPayments"
                dataKey="id"
                :paginator="true"
                :rows="5"
                :filters="filters"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="نمایش {first} تا {last} از {totalRecords} صورت حساب"
              >
                <template #header>
                  <div
                    class="
                      table-header
                      flex flex-column
                      md:flex-row md:justiify-content-between
                    "
                  >
                    <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText
                        class="form-control-register"
                        v-model="filters['global'].value"
                        placeholder="جستجو کنید"
                      />
                    </span>
                  </div>
                </template>
                <Column
                  :style="{ textAlign: 'right' }"
                  :sortable="true"
                  field="Date"
                  header="تاریخ ایجاد"
                >
                  <template #body="slotProps">
                    {{ parseDates(slotProps.data.Date) }}
                  </template>
                </Column>
                <Column
                  :style="{ textAlign: 'right' }"
                  :sortable="true"
                  field="Amount"
                  header="مبلغ"
                >
                  <template #body="slotProps">
                    <span
                      class="minusInPrice"
                      :style="[
                        slotProps.data.Amount < 0
                          ? { color: 'red' }
                          : { color: 'green' },
                      ]"
                    >
                      {{ formatPrice(slotProps.data.Amount) }}
                    </span>
                    <span
                      :style="[
                        slotProps.data.Amount < 0
                          ? { color: 'red' }
                          : { color: 'green' },
                      ]"
                      class="tomanText pl-1"
                    >
                      تومان</span
                    >
                  </template>
                </Column>
                <Column
                  :style="{ textAlign: 'right' }"
                  field="Disc"
                  header="توضیحات"
                >
                </Column>
                <Column
                  :style="{ textAlign: 'right' }"
                  field="Tid"
                  header="شماره تراکنش"
                >
                </Column>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Toast position="top-left" />
</template>

<script>
import Preparing from "../components/Preparing.vue";

import axios from "axios";
import router from "../router/index";
import ls from "localstorage-slim";
import { FilterMatchMode } from "primevue/api";
import { DOMAIN } from "../configs";
import { teacherFields } from "../constants";

export default {
  name: "Finance",
  components: {
    Preparing,
  },
  data() {
    return {
      isPreparing: true,
      checkoutAmount: "",
      checkoutTid: "",
      checkoutAmount: "",
      checkoutTeacher: {},
      fields: teacherFields,
      domain: DOMAIN,
      working: false,
      teacherPayments: [],
      teacherPayments: {},
      filters: {},
      submitted: false,
    };
  },
  methods: {
    async handleCheckout(e) {
      e.preventDefault();
      if (this.checkoutAmount > parseInt(this.checkoutTeacher.Account)) {
        this.working = false;
        this.$toast.add({
          severity: "error",
          summary: "مبلغ پرداختی نباید بیشتر از بدهی شما باشد",
          life: 5000,
        });
        return;
      }
      this.working = true;
      this.checkout();
    },
    sendPayments(c) {
      this.teacherPayments = c;
      this.viewPayments();
    },
    sendPayments(c) {
      this.teacherPayments = c;
      this.viewPayments();
    },
    sendCheckout(c) {
      this.checkoutTeacher = c;
      this.checkoutAmount = parseInt(this.checkoutTeacher.Account);
    },
    async checkout() {
      await axios
        .post("/api/v1/manager/teacher/checkout/", {
          teachid: this.checkoutTeacher.Id,
          amount: this.checkoutAmount,
          disc: "تسویه حساب",
          tid: this.checkoutTid,
        })
        .then((response) => {
          if (response.data.data === "ok") {
            this.$toast.add({
              severity: "success",
              summary: "پرداخت انجام شد",
              life: 5000,
            });
            this.getPayments();
          } else {
            this.working = false;
            this.$toast.add({
              severity: "error",
              summary: "خطا در ثبت پرداخت",
              life: 5000,
            });
          }
        });
      this.working = false;
    },
    viewPayments() {
      ls.set("teacherPaymentsId", this.teacherPayments.Id);
      ls.set("teacherPaymentsName", this.teacherPayments.Name);
      router.push({
        name: "CheckoutTeacher",
      });
    },
    findField(fcode) {
      if (this.fields.find((f) => f.code === fcode) !== undefined) {
        return this.fields.find((f) => f.code === fcode).name;
      } else {
        return "تعیین نشده";
      }
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    async getPayments() {
      this.isPreparing = true;
      await axios
        .post("/api/v1/teacher/user/finance/detail", { teachid: this.me.Id })
        .then((response) => {
          if (response.status === 200) {
            this.teacherPayments = response.data;
            this.isPreparing = false;
          }
        });
    },
  },
  mounted() {
    this.me = JSON.parse(ls.get("user"));
    this.getPayments();
  },
  created() {
    this.initFilters();
  },
};
</script>

<style></style>
